<template>
    <div class="px-2 px-lg-0 mt-3">
        <div class="border p-1 position-relative">
            <span class="share-label fw-bold">Share</span>
            <twitter-button :title="title" v-bind:isBlank="false" btnText :url="currentUrl"/>
            <whats-app-button :title="title" v-bind:isBlank="false" btnText :url="currentUrl"/>
            <telegram-button :title="title" v-bind:isBlank="false" btnText :url="currentUrl"/>
            <tumblr-button :title="title" v-bind:isBlank="false" btnText :url="currentUrl"/>
            <email-button :title="title" v-bind:isBlank="false" btnText :url="currentUrl"/>
            <button class="share-button bp" @click="copyUrl">Copy URL</button>
        </div>
    </div>
</template>

<script>
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import TelegramButton from "vue-share-buttons/src/components/TelegramButton";
import WhatsAppButton from "vue-share-buttons/src/components/WhatsAppButton";
import TumblrButton from "vue-share-buttons/src/components/TumblrButton";
import EmailButton from "vue-share-buttons/src/components/EmailButton";

export default {
    name: "share-profile",
    components: {
        TwitterButton,
        WhatsAppButton,
        TelegramButton,
        TumblrButton,
        EmailButton
    },
    computed: {
        title() {
            return 'Share Profile';
        },
        currentUrl(){
            return window.location.href;
        }
    },
    data() {
        return {}
    },
    mounted() {

    },
    methods: {
        copyUrl() {
            navigator.clipboard.writeText(window.location.href)
                .then(() => {
                    console.log('Url is on the clipboard.');
                    alert('URL copied to clipboard.');
                })
                .catch(e => {
                    console.error(e);
                    alert('Sorry, unable to copy to clipboard.');
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.share-label{
    font-size: 15px;
    position: absolute;
    top: -7px;
    background: white;
    line-height: 15px;
    left: 7px;
}

@media (max-width: 768px) {
    .bp {
        margin: 2px !important;
        padding: 8px !important;
    }
    .share-label{
        top: -9px!important;
    }
}

.bp {
    text-rendering: auto;
    background-color: #c9006c;
    border: none;
    border-radius: 4px;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #fff;
    display: inline-block;
    font-weight: 400;
    letter-spacing: normal;
    margin: 4px;
    min-height: 42px;
    min-width: 42px;
    padding: 10px 8px;
    text-align: center;
    text-indent: 0;
    text-shadow: none;
    -webkit-transition: color .3s ease-in-out, background-color .3s ease-in-out, border-color .3s ease-in-out;
    transition: color .3s ease-in-out, background-color .3s ease-in-out, border-color .3s ease-in-out;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    vertical-align: top;
    word-spacing: normal
}


input {
    border-color: white;
}
</style>
